// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.fase {
  float: left;
  cursor: pointer;
  width: 20%;
}
div.fase div.contenido {
  color: #fff;
  max-width: 300px;
  display: block;
  background: #539cad;
  text-decoration: none;
  position: relative;
  height: 40px;
  line-height: 40px;
  padding: 0 12px 0 5px;
  text-align: center;
  margin-right: 22px;
}
div.fase div.contenido.fase-completa {
  background: #539cad;
}
div.fase:first-child div.contenido {
  padding-left: 15px;
  border-radius: 4px 0 0 4px;
}
div.fase:first-child div.contenido:before {
  border: none;
}
div.fase div.contenido:before, div.fase div.contenido:after {
  content: "";
  position: absolute;
  top: 0;
  border: 0 solid #539cad;
  border-width: 20px 10px;
  width: 0;
  height: 0;
}
div.fase div.contenido:before {
  left: -15px;
  border-left-color: transparent;
}
div.fase div.contenido:after {
  left: 100%;
  border-color: transparent;
  border-left-color: #539cad;
}
div.fase div.contenido.fase-completada {
  background-color: #023b48;
}
div.fase div.contenido.fase-completada:before {
  border-color: #023b48;
  border-left-color: transparent;
}
div.fase div.contenido.fase-completada:after {
  border-left-color: #023b48;
}
div.fase div.contenido:hover {
  background-color: #0a738c;
}
div.fase div.contenido:hover:before {
  border-color: #0a738c;
  border-left-color: transparent;
}
div.fase div.contenido:hover:after {
  border-left-color: #0a738c;
}`, "",{"version":3,"sources":["webpack://./src/app/modulos/crm/components/trato-pop/trato-pop.component.scss","webpack://./src/assets/css/colores.scss"],"names":[],"mappings":"AAWA;EACC,WAAA;EACA,eAAA;EACA,UAAA;AAVD;AAYC;EACC,WAZO;EAaP,gBAAA;EACA,cAAA;EACA,mBCbgB;EDchB,qBAAA;EACA,kBAAA;EACA,YAdO;EAeP,iBAfO;EAgBP,qBAAA;EACA,kBAAA;EACA,kBAAA;AAVF;AAWE;EACC,mBCtBe;ADalB;AAaE;EACC,kBAAA;EACA,0BAAA;AAXH;AAYG;EACC,YAAA;AAVJ;AAeE;EAEC,WAAA;EACA,kBAAA;EACA,MAAA;EACA,uBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AAdH;AAgBE;EACC,WAAA;EACA,8BAAA;AAdH;AAgBE;EACC,UAAA;EACA,yBAAA;EACA,0BCpDe;ADsClB;AAgBE;EACC,yBCxDe;AD0ClB;AAgBG;EACC,qBC3Dc;ED4Dd,8BAAA;AAdJ;AAgBG;EACC,0BC/Dc;ADiDlB;AAiBE;EACC,yBCpEc;ADqDjB;AAiBG;EACC,qBCvEa;EDwEb,8BAAA;AAfJ;AAiBG;EACC,0BC3Ea;AD4DjB","sourcesContent":["@import \"../../../../../assets/css/colores.scss\";\n\n$fondo-normal: $oa-secundario3;\n$fondo-activo: $oa-secundario2;\n$fondo-hover: $oa-secundario;\n$letras: #fff;\n$color-icono: #555555;\n$titulo-size: 1rem;\n$subtitulo-size: 0.75rem;\n$altura: 40px; // debe ser numero par\n\ndiv.fase {\n\tfloat: left;\n\tcursor: pointer;\n\twidth: 20%;\n\n\tdiv.contenido {\n\t\tcolor: $letras;\n\t\tmax-width: 300px;\n\t\tdisplay: block;\n\t\tbackground: $fondo-normal;\n\t\ttext-decoration: none;\n\t\tposition: relative;\n\t\theight: $altura;\n\t\tline-height: $altura;\n\t\tpadding: 0 12px 0 5px;\n\t\ttext-align: center;\n\t\tmargin-right: 22px;\n\t\t&.fase-completa {\n\t\t\tbackground: $fondo-normal;\n\t\t}\n\t}\n\t&:first-child {\n\t\tdiv.contenido {\n\t\t\tpadding-left: 15px;\n\t\t\tborder-radius: 4px 0 0 4px;\n\t\t\t&:before {\n\t\t\t\tborder: none;\n\t\t\t}\n\t\t}\n\t}\n\tdiv.contenido {\n\t\t&:before,\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tborder: 0 solid $fondo-normal;\n\t\t\tborder-width: $altura/2 10px;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t\t&:before {\n\t\t\tleft: -15px;\n\t\t\tborder-left-color: transparent;\n\t\t}\n\t\t&:after {\n\t\t\tleft: 100%;\n\t\t\tborder-color: transparent;\n\t\t\tborder-left-color: $fondo-normal;\n\t\t}\n\t\t&.fase-completada {\n\t\t\tbackground-color: $fondo-activo;\n\n\t\t\t&:before {\n\t\t\t\tborder-color: $fondo-activo;\n\t\t\t\tborder-left-color: transparent;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tborder-left-color: $fondo-activo;\n\t\t\t}\n\t\t}\n\t\t&:hover {\n\t\t\tbackground-color: $fondo-hover;\n\n\t\t\t&:before {\n\t\t\t\tborder-color: $fondo-hover;\n\t\t\t\tborder-left-color: transparent;\n\t\t\t}\n\t\t\t&:after {\n\t\t\t\tborder-left-color: $fondo-hover;\n\t\t\t}\n\t\t}\n\t}\n}\n","\n$oa-principal : #d20a31;\n$oa-principal2 : #6d0015;\n$oa-principal3 : #f06f88;\n\n$oa-secundario : #0a738c;\n$oa-secundario2 : #023b48;\n$oa-secundario3 : #539cad;\n\n$oa-accent : #46c309;\n$oa-accent2 : #216500;\n$oa-accent3 : #90e268;\n\n$oa-accent-secundario : #E1750B;\n$oa-accent-secundario2 : #753A00;\n$oa-accent-secundario3 : #FFBA76;\n\n$oa-background : #023b48;\n\n$oa-blanco-bg : white;\n$oa-blanco : white;\n\n$oa-gris : #6e6e6e;\n$oa-gris-claro : #a3a3a3;\n$oa-gris-oscuro : #424242;\n\n$oa-color-link: #3e92ff;\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
